<template>
  <div
    class="p-config-candidates-list"
    :class="{ 'is-selected': isSelectedList && hasChecked }"
  >
    <div
      v-if="isSelectedList && !hasChecked"
      class="p-config-candidates-list__guide"
    >
      <p>左の候補を選択すると、<br />選択したものがここに表示されます。</p>
    </div>
    <template v-else>
      <div class="p-config-candidates-list__header">
        <div
          class="p-config-candidates-list__col p-config-candidates-list__col--check"
        ></div>
        <div class="p-config-candidates-list__col">
          サイト名
        </div>
        <div class="p-config-candidates-list__col">
          サイトURL
        </div>
      </div>
      <div class="p-config-candidates-list__content">
        <perfect-scrollbar
          :options="{ suppressScrollX: true, minScrollbarLength: 10 }"
          ref="scroll"
        >
          <div class="p-config-candidates-list__inner">
            <ListItemProjectCandidates
              v-for="item in items"
              :key="item.id"
              :checked="checked"
              :input="input"
              :item="item"
              :type="type"
              @change="change"
            />
          </div>
        </perfect-scrollbar>
      </div>
    </template>
  </div>
</template>

<script>
import ListItemProjectCandidates from '@/components/config/ListItemProjectCandidates';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';

export default {
  props: {
    checked: {
      type: [Array, String],
      required: true
    },
    input: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      required: false
    }
  },
  components: {
    ListItemProjectCandidates,
    PerfectScrollbar
  },
  computed: {
    hasChecked() {
      if (this.input === 'checkbox') {
        return this.checked.length ? true : false;
      } else {
        return Object.keys(this.checked).length ? true : false;
      }
    },
    isSelectedList() {
      return this.type === 'selected';
    }
  },
  methods: {
    change(checked) {
      this.$emit('change', checked);
    }
  }
};
</script>
